module.exports = __webpack_public_path__ + "static/media/09.2a80bb07.jpg";